export const getInitialStatus = status => status === 'suspended' ? 'unsuspend' : 'suspend';

export const getNewStatus = status => status === 'suspend' ? 'unsuspend' : 'suspend';
